import React, { useEffect } from 'react';

const CookiePolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">Cookie Policy</h1>
                <div className="content">
                    <p>This Cookie Policy explains how <strong>Paymond Services Private Limited</strong> uses cookies and similar technologies to recognize you when you visit our website at <strong>https://Paymond.in</strong>.</p>

                    <h3>What are cookies?</h3>
                    <p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>

                    <h3>Why do we use cookies?</h3>
                    <p>We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our Website to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies also enable us to track and target the interests of our users to enhance the experience on our Online Sections. Third parties serve cookies through our Website for advertising, analytics and other purposes.</p>

                    <h3>How can I control cookies?</h3>
                    <p>You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted.</p>

                    <h3>Changes to this Cookie Policy</h3>
                    <p>We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.</p>

                    <h3>Contact Us</h3>
                    <p>If you have any questions about our use of cookies or other technologies, please email us at <strong>paymondtechnologies@gmail.com</strong>.</p>
                </div>
            </div>
        </section>
    );
};

export default CookiePolicy;
